// Surety (Mercury): a percentage on the final score that every removal in
// the play, before or after the choice, wears down (Aaron, 2026-11-04).
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentContext, AlignmentDef } from '../types';

export function suretyPercent(removals: number): number {
  return Math.max(0, N.suretyPercent - N.suretyStep * removals);
}

export const surety: AlignmentDef = {
  id: 'surety',
  planet: 'mercury',
  name: 'Surety',
  text: (ctx: AlignmentContext | null) =>
    `Your final score is increased by +${N.suretyPercent}%, less ${N.suretyStep}% for each constellation you remove. Currently +${suretyPercent(ctx?.removals ?? 0)}%.`,
  finalPercent: (ctx) => suretyPercent(ctx.removals),
};
